import {useEffect} from 'react';

import MojitoCore from 'mojito/core';
import MojitoApplications from 'mojito/applications';

import {removeStartingSlash} from '#core/utils/url-utils.js';
import {getExternalUrlIntent} from '#core/utils/intent-factory.js';
import {ensureHierarchy, merge, mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './routes.schema.yaml';

const {dispatch} = MojitoCore.Services.redux.store;
const IntentActions = MojitoCore.Intents.actions;
const {RouteResolver, RouterStore} = MojitoApplications.Common;

const mojitoPaths = IS_LOTTO ? MojitoApplications.Lotto.PATHS : MojitoApplications.Sports.PATHS;

class RoutesFeature extends AbstractFeature {
    get configSchema() {
        return SCHEMA;
    }

    // eslint-disable-next-line no-unused-vars
    setupConfigs(globalConfig, options, filterFn) {
        super.setupConfigs(...arguments);

        this.routingPrefix = options.routingPrefix;
        this.routeResolver = null;
    }

    beforeMojito() {
        const paths = merge(mojitoPaths, this.config.override || {});
        this.routeResolver = new RouteResolver(paths, this.routingPrefix);

        RouterStore.routeResolverFactory.setRouteResolver(this.routeResolver); // Set router resolver to store directly, before moj init, for earlier access

        return super.beforeMojito();
    }

    updateMojitoConfig(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'application.stores.router', {
            routeResolver: this.routeResolver, // duplicate it here
        });

        super.updateMojitoConfig(mojitoConfig);
    }

    updateViewsConfig(viewsConfig) {
        const RoutingView = ensureHierarchy(viewsConfig, 'RoutingView');
        RoutingView.customRoutes = RoutingView.customRoutes || [];

        (this.config.add || []).forEach(item => {
            if (!item.path || !item.action) return;
            const path = this.routeResolver.enrichWithRoot(removeStartingSlash(item.path));
            const action = getExternalUrlIntent(item.action);

            const component = () => {
                useEffect(() => {
                    if (action) dispatch(IntentActions.publishIntent(action.type, action.data));
                }, []);

                return null;
            };

            RoutingView.customRoutes.push({path, component});
        });

        super.updateViewsConfig(viewsConfig);
    }
}

export const Routes = new RoutesFeature(allFeatures);
